import { NotificationPreviewList } from './NotificationPreviewList';

export default {
    list: NotificationPreviewList,
};
